// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"c7c8c6b8b1c149f2eab4","883":"d301c2301d03d8faac3c"}[chunkId] + ".js";
};